import { idGenerator } from '@/services'

export interface ConstructionConnectionState {
  requestId: string
}

export const InitialState: ConstructionConnectionState = {
  requestId: idGenerator.getNewWebReference()
}
